import { Ticket, Laptop, User } from "lucide-react";
import { useAzure } from "@/context/AzureContext";
import { Table, TableHeader, TableBody, TableRow, TableHead, TableCell } from "@/components/ui/table";

const PRIO = { P1: "text-red-600", P2: "text-amber-600", P3: "text-blue-600" };
const STATUS = {
  New: "bg-blue-500/10 text-blue-600", "In Progress": "bg-amber-500/10 text-amber-600",
  Resolved: "bg-emerald-500/10 text-emerald-600", Closed: "bg-muted text-muted-foreground",
};

export default function Operations() {
  const { state } = useAzure();
  const tickets = state?.tickets || [];
  const devices = state?.devices || [];
  return (
    <div data-testid="az-operations">
      <div className="flex items-center gap-2 border-b border-border pb-3 mb-3">
        <Ticket className="h-5 w-5 text-[#0078d4]" /><h2 className="font-semibold">IT Operations — open tickets</h2>
      </div>
      <div className="border border-border rounded-md overflow-hidden" data-testid="az-tickets">
        <Table>
          <TableHeader><TableRow><TableHead>Number</TableHead><TableHead>Priority</TableHead><TableHead>Short description</TableHead><TableHead>Caller</TableHead><TableHead>Assignment group</TableHead><TableHead>State</TableHead></TableRow></TableHeader>
          <TableBody>
            {tickets.map((t) => (
              <TableRow key={t.id} data-testid={`az-ticket-${t.id}`}>
                <TableCell className="font-mono text-xs text-[#0078d4]">{t.id}</TableCell>
                <TableCell className={`font-semibold ${PRIO[t.priority] || ""}`}>{t.priority}</TableCell>
                <TableCell>{t.short_description}</TableCell>
                <TableCell className="text-xs">{t.caller}</TableCell>
                <TableCell className="text-xs">{t.assignment_group}</TableCell>
                <TableCell><span className={`text-xs px-2 py-0.5 rounded ${STATUS[t.status] || ""}`}>{t.status}</span></TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>

      <div className="flex items-center gap-2 border-b border-border pb-3 mb-3 mt-8">
        <Laptop className="h-5 w-5 text-[#0078d4]" /><h2 className="font-semibold">Corporate devices (Intune)</h2>
      </div>
      <div className="border border-border rounded-md overflow-hidden" data-testid="az-devices">
        <Table>
          <TableHeader><TableRow><TableHead>Device</TableHead><TableHead>OS</TableHead><TableHead>Owner</TableHead><TableHead>Department</TableHead><TableHead>Compliance</TableHead><TableHead>Last check-in</TableHead></TableRow></TableHeader>
          <TableBody>
            {devices.map((d) => (
              <TableRow key={d.id} data-testid={`az-device-${d.name}`}>
                <TableCell className="font-medium">{d.name}</TableCell>
                <TableCell className="text-xs">{d.os}</TableCell>
                <TableCell className="text-xs flex items-center gap-1"><User className="h-3 w-3" /> {d.owner}</TableCell>
                <TableCell className="text-xs">{d.department}</TableCell>
                <TableCell className={`text-xs font-medium ${d.compliance === "Compliant" ? "text-emerald-600" : "text-red-600"}`}>{d.compliance}</TableCell>
                <TableCell className="text-xs text-muted-foreground">{(d.last_checkin || "").slice(0, 10)}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
